<template>
  <div>
    <div class="header">
      <h1 class="header-title">Add New User</h1>
      <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a href="#">Dashboard</a>
          </li>
          <li class="breadcrumb-item">
            <a href="#">Users</a>
          </li>
          <li class="breadcrumb-item active" aria-current="page">Create</li>
        </ol>
      </nav>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <form @submit.prevent="submit" id="create_form">
              <div class="row">
                <div class="col-md-6 mb-3">
                  <label>Email</label>
                  <input
                    type="text"
                    placeholder="Email"
                    v-model="user.email"
                    class="form-control"
                    name="email"
                  />
                </div>
                <div class="col-md-6 mb-3">
                  <label>Role</label>
                  <select name="role" class="form-control" v-model="user.role">
                    <option value="writer">Writer</option>
                    <option value="admin">Admin</option>
                  </select>
                </div>
                <div class="col-md-12 text-end">
                  <button class="btn btn-primary">
                    <i class="fal fa-save"></i>Save
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      user: { role: 'writer' }
    }
  },

  methods: {
    submit() {
      let data = this.user
      data.form_id = 'create_form'

      this.$axios.post('/api/v1/admin/users', data).then(response => {
        this.$router.push({ name: 'admin.users.show', params: { id: response.data.id }})
      })
    }
  }
};
</script>
